import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import { FaHome, FaChevronRight } from 'react-icons/fa';
import '../../assets/css/admin/adminDashboard/admbreadcrumb.css';

const AdminBreadcrumb = () => {
  const location = useLocation();

  const routeLabels = {
    // Dashboard
    'dashboard': 'Dashboard',
    
    // Users
    'users': 'User Management',
    'customers': 'Customers',
    'vendors': 'Vendors',
    'admins': 'Administrators',
    
    // Vendors
    'all': 'All Vendors',
    'commission': 'Commission Management',
    'activity': 'Vendor Activity',
    'reports': 'Vendor Reports',
    
    // Packages
    'packages': 'Package Management',
    'pack-dashboard': 'Package Dashboard',
    'list': 'Package List',
    'bookings': 'Bookings',
    'revenue': 'Revenue',
    'analytics': 'Analytics',
    
    // Reviews
    'reviews': 'Reviews Management',
    'reviews-dashboard': 'Reviews Dashboard',
    'flagged': 'Flagged Reviews',
    
    // Vendor Management
    'vendor-management': 'Vendor Management',
    
    // Notifications
    'notifications': 'Notifications',
    
    // Blogs
    'blogs': 'Blogs Management',
    
    // Settings
    'settings': 'Settings',
    'profile': 'Profile Settings',
    'password': 'Password Settings',
    
    // Support
    'support-tickets': 'Support Tickets',
    
    // Destinations
    'destinations': 'Destination Management',
  };

  const formatLabel = (segment) => {
    if (routeLabels[segment.toLowerCase()]) {
      return routeLabels[segment.toLowerCase()];
    }
    
    return segment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const generateBreadcrumbs = () => {
  const pathnames = location.pathname.split('/').filter(x => x);
  const breadcrumbs = [
      {
        label: 'Dashboard',
        path: '/admin/dashboard',
        icon: <FaHome />,
        isActive: pathnames.length === 1 || (pathnames.length === 2 && pathnames[1] === 'dashboard')
      }
    ];

    if (pathnames.length <= 2 && pathnames[1] === 'dashboard') {
      return breadcrumbs;
    }

    let currentPath = '';
    pathnames.forEach((segment, index) => {
      if (segment.toLowerCase() === 'admin') {
        currentPath += '/admin';
        return;
      }
      
      currentPath += `/${segment}`;
      const isLast = index === pathnames.length - 1;
      
      if (!isNaN(segment)) {
        return;
      }
      
      breadcrumbs.push({
        label: formatLabel(segment),
        path: currentPath,
        isActive: isLast
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <div className="adm-breadcrumb-wrapper">
      <Breadcrumb className="adm-breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <Breadcrumb.Item
            key={index}
            active={crumb.isActive}
            linkAs={crumb.isActive ? 'span' : Link}
            linkProps={crumb.isActive ? {} : { to: crumb.path }}
            className={crumb.isActive ? 'adm-breadcrumb-active' : 'adm-breadcrumb-link'}
          >
            {index === 0 && crumb.icon && (
              <span className="adm-breadcrumb-icon">{crumb.icon}</span>
            )}
            {crumb.label}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default AdminBreadcrumb;